export const ZOOM_EMBED_MESSAGE_TYPES = {
  RESIZE: 'zcc-resize',
  CLICK_TO_CALL: 'onclicktoact'
}

export const ZOOM_EMBED_EXPAND_EVENT = 'zoom-embed:expand'

/** Must match ZoomEmbedWidget iframe id — used by dialZoomPhone postMessage */
export const ZOOM_EMBED_IFRAME_ID = 'zoom-embeddable-phone-iframe'

/**
 * Zoom CC Smart Embed engagement events we log for observation.
 * Docs: https://developers.zoom.us/docs/contact-center/smart-embed/
 */
export const ZOOM_ENGAGEMENT_LOG_CATEGORIES = {
  INBOUND_CALL: 'inbound_call',
  INBOUND_CHAT: 'inbound_chat',
  INBOUND_EMAIL: 'inbound_email',
  INBOUND_OMNI: 'inbound_omni',
  OUTBOUND_CALL: 'outbound_call'
}

/**
 * Channel values from Zoom payloads (data.channel / data.channelType / objectRecord.type)
 * mapped to log categories.
 */
export const ZOOM_CHANNEL_TO_CATEGORY = {
  voice: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_CALL,
  phone: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_CALL,
  chat: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_CHAT,
  email: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_EMAIL,
  // Omni / messaging digital channels
  sms: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  video: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  messaging: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  omni: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  whatsapp: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  facebook: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  messenger: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI,
  in_app_chat: ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI
}

export const ZOOM_ENGAGEMENT_EVENT_TYPES = {
  // โทรเข้า
  [ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_CALL]: [
    'zcc-call-ringing',
    'zcc-incomingPhone-request',
    'zcc-call-connected',
    'zcc-call-ended',
    'zcc-inbound-not-connected'
  ],
  // Chat เข้า
  [ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_CHAT]: [
    'zcc-chat-ringing',
    'zcc-chat-started',
    'zcc-chat-ended'
  ],
  // Email เข้า (contact match + email-named events)
  [ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_EMAIL]: [
    'zcc-incomingEmail-request'
  ],
  // Omni / messaging (SMS, video, และ digital อื่น ๆ)
  [ZOOM_ENGAGEMENT_LOG_CATEGORIES.INBOUND_OMNI]: [
    'zcc-sms-ringing',
    'zcc-sms-started',
    'zcc-sms-ended',
    'zcc-video-ringing',
    'zcc-video-started',
    'zcc-video-ended'
  ],
  // โทรออก
  [ZOOM_ENGAGEMENT_LOG_CATEGORIES.OUTBOUND_CALL]: [
    'zcc-outbound-call-started',
    'zcc-outbound-not-connected'
  ]
}

/**
 * Events that carry channel / channelType — category resolved from payload.
 * Still logged at info when channel maps to chat / email / omni / voice.
 */
export const ZOOM_CHANNEL_AWARE_EVENT_TYPES = [
  'zcc-incomingEmail-request',
  'zcc-incomingPhone-request',
  'zcc-accept-engagement',
  'zcc-reject-engagement',
  'zcc-terminate-engagement',
  'zcc-set-engagement-disposition',
  'zcc-close-engagement-wrapup',
  'zcc-engagement-status-response',
  'zcc-engagement-log-url',
  'zcc-add-note',
  'zcc-call-recording'
]

/** Call-log event — category resolved from payload.callType / type */
export const ZOOM_PHONE_CALL_LOG_TYPE = 'zcc-phone-call-log'

/** Fired when the agent answers a call — used for inbound ticket screen-pop */
export const ZOOM_CALL_CONNECTED_TYPE = 'zcc-call-connected'

export const ZOOM_PANEL_HEADER_HEIGHT = 44

export const ZOOM_EMBED_IFRAME_SANDBOX = 'allow-forms allow-popups allow-popups-to-escape-sandbox allow-scripts allow-same-origin allow-downloads'

export const ZOOM_EMBED_IFRAME_ALLOW = 'autoplay; microphone; camera; display-capture; midi; encrypted-media; clipboard-write'
